import { render, staticRenderFns } from "./userVip.vue?vue&type=template&id=3e01f54e&scoped=true&"
import script from "./userVip.vue?vue&type=script&lang=js&"
export * from "./userVip.vue?vue&type=script&lang=js&"
import style0 from "./userVip.vue?vue&type=style&index=0&id=3e01f54e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e01f54e",
  null
  
)

export default component.exports